module.exports = __webpack_public_path__ + "static/media/name-key-figure.c120fb61.png";